<template>


    <button type="submit" @click.prevent="save()"
            :class="{'mb-2':marginBottom, 'mr-2':marginRight, 'disabled-external':disabled}"
            class="btn-pill btn-shadow btn-wide fsize-1 btn btn-primary" :disabled="disabled || clicked">


        <div class="img-loading" v-if="clicked">

            <div class="loader">
                <div class="ball-clip-rotate-multiple">
                    <div style="width: 15px; height: 15px; border-color: rgb(255, 255, 255) transparent;"></div>
                    <div style="width: 15px; height: 15px; left: -20px; top: -20px; border-color: #fff transparent #fff transparent;"></div>
                </div>
            </div>

        </div>
        {{text}}

    </button>

</template>

<script>
    export default {
        name: "v-button",
        props: {
            disabled: {
                type: Boolean,
                default: false
            },
            marginBottom: {
                type: Boolean,
                default: true
            },
            marginRight: {
                type: Boolean,
                default: true
            },
            text: {
                type: String,
                default: 'Salvar'
            },
            clicked: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            save() {
                this.$emit('save')
            }
        }


    }
</script>

<style scoped>
    .img-loading {
        width: 25px;
        height: 25px;
        position: absolute;
        left: 0px;
        transition: all 0.5s ease-in-out;
    }

    .img-loading img {
        position: absolute;
        left: -25px;
        top: -12px;
        width: 45px;
        height: 45px;
    }

    button {
        transition: all 0.5s ease-in-out;
        line-height: 19px;
    }

    button[disabled] {
        padding-left: 32px;
    }

    button[disabled].disabled-external {
        padding-left: 2rem;
    }

    button[disabled] .img-loading {
        left: 45px;
        top: 32px;
    }

    button[disabled].disabled-external .img-loading {
        left: 0;
        top: 0;
    }
</style>
